export default __webpack_public_path__ + "static/08.03-f8f60ce4322e081b192c69d541bf2a81.png";